import { ArrowRight } from "lucide-react";
import { Reveal } from "./motion";
import { HONEYBOOK_URL } from "../data/site";

export const CtaBand = ({ heading, subtext }) => (
    <section
        data-testid="cta-band"
        className="relative bg-[#554011] py-24 sm:py-32 overflow-hidden"
    >
        <div className="absolute inset-0 opacity-[0.12] bg-[radial-gradient(circle_at_30%_20%,#FFD2CE,transparent_55%),radial-gradient(circle_at_75%_80%,#C18E8B,transparent_50%)]" />
        <div className="relative max-w-3xl mx-auto px-5 text-center">
            <Reveal>
                <p className="font-accent text-xs uppercase tracking-[0.25em] text-[#FFD2CE] mb-5">
                    McKinney · Dallas-Fort Worth
                </p>
            </Reveal>
            <Reveal delay={0.1}>
                <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#FAF7F2] leading-tight">
                    {heading || "Ready to plan your escape?"}
                </h2>
            </Reveal>
            <Reveal delay={0.2}>
                <p className="mt-5 text-[#FAF7F2]/75 leading-relaxed">
                    {subtext ||
                        "Tell us about your occasion and we'll design a styled outdoor experience you'll never forget."}
                </p>
            </Reveal>
            <Reveal delay={0.3}>
                <a
                    href={HONEYBOOK_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="cta-band-book-button"
                    className="mt-9 inline-flex items-center gap-2 bg-[#FFD2CE] hover:bg-[#FAF7F2] text-[#3D2E0A] px-9 py-4 rounded-full font-accent text-xs uppercase tracking-[0.18em] font-semibold transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-[1.04]"
                >
                    Inquire Through HoneyBook <ArrowRight className="w-4 h-4" />
                </a>
            </Reveal>
        </div>
    </section>
);

export const FloatingCta = () => (
    <a
        href={HONEYBOOK_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-book-button"
        className="fixed bottom-5 right-5 z-40 md:hidden bg-[#C18E8B] text-[#FAF7F2] px-6 py-3.5 rounded-full font-accent text-xs uppercase tracking-[0.15em] shadow-xl hover:bg-[#554011] transition-colors"
    >
        Book Your Escape
    </a>
);
